/**
 * Formats a YYYY-MM-DD date string to MM/DD/YYYY.
 * Uses string splitting to avoid timezone shift issues.
 * @param {string} dateStr
 * @param {string} fallback - returned when dateStr is empty/null
 */
export function formatDate(dateStr, fallback = '-') {
    if (!dateStr) return fallback;
    try {
        // Handle both YYYY-MM-DD and full ISO datetime strings
        const datePart = dateStr.includes('T')
            ? dateStr.split('T')[0]
            : dateStr;

        const [year, month, day] = datePart.split('-');
        return `${month}/${day}/${year}`;
    } catch {
        return dateStr;
    }
}

/**
 * Formats a number as USD currency.
 * @param {number} val
 * @param {string} fallback - returned when val is null/undefined
 * @param {number} fractionDigits
 */
export function formatCurrency(val, fallback = '-', fractionDigits = 2) {
    if (val == null || val === '') return fallback;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: fractionDigits,
    }).format(val);
}